/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

module.exports = require('dispatchr/addons/BaseStore');



//////////////////
// WEBPACK FOOTER
// ./~/fluxible/addons/BaseStore.js
// module id = 13
// module chunks = 64